import axios from "axios";

export const sriSyncLogApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/sri-sync-log`,
  headers: {
    "Content-Type": "application/json",
  },
});
